import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["items", "label", "languageSelector", "legalHubLinks", "socialMediaLinks"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Col, Container, Row, SKIP_LINK_TARGETS } from '@mirohq-internal/website-ui-foundation';
import { BrandAttributionBlock } from '../brand-attribution-block/brand-attribution-block';
import { LanguageSelector } from '../language-selector/language-selector';
import { LegalHub } from '../legal-hub/legal-hub';
import { AppStoreBadges } from './components/app-store-badges';
import { ResponsiveLinkList } from './components/responsive-link-list';
import { SocialMediaLinks } from './components/social-media-links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MiroFooter = function MiroFooter(_ref) {
  var items = _ref.items,
      label = _ref.label,
      languageSelector = _ref.languageSelector,
      legalHubLinks = _ref.legalHubLinks,
      socialMediaLinks = _ref.socialMediaLinks,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (!items) {
    return null;
  }

  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({
    fluid: true,
    className: "p-0 overflow-hidden pt-xl-600",
    style: {
      backgroundColor: '--section-colors-bg-section-color-4',
      color: '--text-colors-text-alt-text-static-tertiary'
    },
    id: SKIP_LINK_TARGETS.FOOTER_NAVIGATION,
    "data-skip-link": label
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "container container-xl p-0 px-xl-300 ",
      children: /*#__PURE__*/_jsx(Row, {
        flexDirection: ['column', 'column', 'column', 'column', 'row', 'row'],
        children: /*#__PURE__*/_jsx(Col, {
          className: "d-flex flex-column flex-xl-row gap-xl-300 justify-content-between mb-xl-600",
          children: items === null || items === void 0 ? void 0 : items.map(function (group) {
            var _group$items;

            return /*#__PURE__*/_jsx(React.Fragment, {
              children: group === null || group === void 0 ? void 0 : (_group$items = group.items) === null || _group$items === void 0 ? void 0 : _group$items.map(function (item) {
                return /*#__PURE__*/_jsx(React.Fragment, {
                  children: /*#__PURE__*/_jsx(ResponsiveLinkList, {
                    label: "".concat(group.label),
                    items: item.items,
                    showAllLink: item.showAllLink
                  })
                }, JSON.stringify(item.items));
              })
            }, JSON.stringify(group.items));
          })
        })
      })
    }), /*#__PURE__*/_jsx("hr", {
      className: "d-none d-xl-block"
    }), /*#__PURE__*/_jsx("div", {
      className: "container-xl",
      children: /*#__PURE__*/_jsxs(Row, {
        className: "d-flex flex-column align-items-center pt-400 gap-200",
        children: [/*#__PURE__*/_jsxs(Col, {
          className: "d-flex flex-column align-items-center gap-300 flex-md-row justify-content-between",
          children: [/*#__PURE__*/_jsxs("span", {
            className: "d-flex flex-column flex-md-row gap-300",
            children: [socialMediaLinks && /*#__PURE__*/_jsx(SocialMediaLinks, {
              socialMediaLinks: socialMediaLinks
            }), languageSelector && /*#__PURE__*/_jsx(LanguageSelector, _objectSpread({}, languageSelector))]
          }), /*#__PURE__*/_jsx(AppStoreBadges, {})]
        }), /*#__PURE__*/_jsxs(Col, {
          className: "d-flex flex-column align-items-md-baseline align-items-center px-300 px-md-150 pt-200 pb-400 gap-400 flex-md-row justify-content-between justify-content-lg-start",
          children: [/*#__PURE__*/_jsx(BrandAttributionBlock, {}), /*#__PURE__*/_jsx("div", {
            className: "d-inline-flex flex-column gap-300 flex-wrap align-items-center flex-md-row",
            children: /*#__PURE__*/_jsx(LegalHub, {
              legalHubLinks: legalHubLinks
            })
          })]
        })]
      })
    })]
  }));
};